import { getFormValues } from 'redux-form'
import { getAppointments } from 'selectors/getAppointments'
import { APPOINTMENT_FORM_NAME } from 'constant'
import StoreAndServices from './components/StoreAndServices'
import DateTimeAndVehicle from './components/DateTimeAndVehicle'
import ContactInfoAndReview from './components/ContactInfoAndReview'

export const getAppointmentFormValues = getFormValues(APPOINTMENT_FORM_NAME)

export const getCompletedSteps = state => {
  const {
    activeVehicleId,
    selectedStore,
    catalogRefIds,
    appointmentDate,
    firstName,
    lastName,
    phoneNumber,
    email,
    userPlan
  } = getAppointmentFormValues(state) || {}


  const { isTrailer } = getAppointments(state)

  const steps = [
    {
      title: 'Services',
      cartridgeType: ['BOTServicesSelector', 'BOTStoreLocation'],
      component: StoreAndServices,
      isDone: Boolean(selectedStore && catalogRefIds && catalogRefIds.length)
    },
    {
      title: 'Date & Vehicle',
      cartridgeType: 'BOTVehicleSelector',
      component: DateTimeAndVehicle,
      isDone: Boolean(appointmentDate && appointmentDate.time && (activeVehicleId || isTrailer))
    },
    {
      title: 'Review',
      component: ContactInfoAndReview,
      isDone: Boolean(firstName && lastName && phoneNumber && email && userPlan)
    }
  ]

  const firstUndoneStepIndex = steps.findIndex(step => !step.isDone)
  const allDone = firstUndoneStepIndex === -1

  for (let i = 0; i < steps.length; i += 1) {
    steps[i].isDone = allDone || i < firstUndoneStepIndex
    steps[i].isActive = allDone || i <= firstUndoneStepIndex
  }

  return steps
}
